import route from '@MAIN/route'

let cache = {

}

export default {
  add(product_id) {
    return new Promise(resolve => {
      $.post(route('api.cart.update'),{
        action: 'add',
        product_id,
        amount: 1
      }, resolve)
    })
  },

  remove(purchase_idx, hash = null) {
    return new Promise(resolve => {
      $.post(route('api.cart.remove'),{
        purchase_idx,
      }, resolve)
    })
  },

  update_amount(purchase_idx, amount) {
    return new Promise(resolve => {
      $.post(route('api.cart.change_amount'),{
        purchase_idx,
        amount
      }, resolve)
    })
  },

  update_coupon(coupon, email) {
    return new Promise(resolve => {
      $.post(route('api.cart.coupon_update'), {coupon}, resolve)
    })
  },

  get_related_products(ids) {
    return new Promise(resolve => {
      $.post(route('api.cart.related_products'), {
        product_ids : ids
      }, function(products) {
        resolve(products)
      })
    })
  },

  get_last_order_data() {
    return new Promise(resolve => {
      $.post(route('api.cart.get_last_order_data'), resolve)
    })
  },

}
